import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import { useAxiosGet } from './api/apiHook';
import { Preloader as LoadingSpinner, Oval } from "react-preloader-icon";
import { useParams } from 'react-router-dom';
import { LandingPage } from './landing/LandingPage';
import { ErrorPage } from './components/error/ErrorPage';
import { BusinessPage } from './components/business/BusinessPage';
import { WeddingPage } from './components/wedding/WeddingPage';
import { setHeaderInfo } from './HeaderUtil';
import { useEffect } from 'react';

function App() {
  const { domain } = useParams()

  const { data: card, error, loaded } = useAxiosGet(
    `cards/findByDomain/`,
    { domain },
  );

  const isTenantDisabled = (card) => card?.name?.startsWith("XXX_");

  const card_type = card?.card_type;

  useEffect(() => {
    if (card?.name) {
      setHeaderInfo(card);
    }
  }, [card]);

  return (
    <>
      { !domain && <LandingPage/> }
      { (domain && (error || isTenantDisabled(card))) && <ErrorPage/> }
      { !loaded && <div className="loadingSpinner"> <LoadingSpinner
          use={Oval}
          size={32}
          strokeWidth={8}
          strokeColor="#F0AD4E"
          duration={800}
        />  </div> }
      { loaded && card && card_type === 'wedding' &&
        <WeddingPage card={card} />
      }
      { loaded && card && card_type !== 'wedding' &&
        <BusinessPage card={card} />
      }
    </>
  );
};

export default App;
